var map = {
	"./gdg.svg": 9912,
	"./ghana.png": 2344,
	"./ghana.svg": 2718,
	"./group.svg": 1599,
	"./kenya.svg": 8810,
	"./naij.png": 9299,
	"./nigeria.svg": 9629,
	"./osca.svg": 6434,
	"./rwanda.svg": 3961,
	"./shecodeafrica.svg": 3390,
	"./southy.png": 7947,
	"./southy.svg": 5065,
	"./web3.svg": 9019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1154;